import userApi from '@/store/userApi'
import { Auth } from 'aws-amplify'

const user = {
  state: {
    user: null,
    subscription: null,
    secondary: {
      name: null,
      number: null
    },
    address: null,
    error: null,
    family: null,
    profile: null
  },
  mutations: {
    setUser: function (state, data) {
      state.user = data
      state.subscription =
        data && data.attributes && data.attributes['custom:subscription']
          ? JSON.parse(data.attributes['custom:subscription'])
          : null
      state.address =
        data && data.attributes && data.attributes['custom:address']
          ? JSON.parse(data.attributes['custom:address'])
          : null
      state.family =
        data && data.attributes && data.attributes['custom:accountMembers']
          ? JSON.parse(data.attributes['custom:accountMembers']).members
          : null
      state.secondary =
          data && data.attributes && data.attributes['custom:secondary_contact']
            ? JSON.parse(data.attributes['custom:secondary_contact'])
            : {
              name: null,
              number: null
            }
    },
    setRegistrationError: function (state, data) {
      state.error = data
    },
    setProfile: function (state, data) {
      state.profile = data
    }
  },
  actions: {
    submitRegistration: async function (context, regForm) {
      console.log('Store - User - Submit Registration')
      let result = await userApi.createSubscription(regForm)
      console.log('Received Response')
      console.log(result)
      if (!result.hasError) {
        console.log('Registration Successful')
        context.dispatch('refreshUser')
        return result
      }

      context.commit('setRegistrationError', result.error.message)
      return result
    },
    getUser: async function (context) {
      console.log('Store - User - Get Cognito User')
      let user = await Auth.currentAuthenticatedUser()
      if (user && user.signInUserSession) {
        context.commit('setUser', user)
        return user
      }
    },
    refreshUser: async function (context) {
      console.log('Store - User - Get Fresh Cognito User')
      let user = await Auth.currentAuthenticatedUser({
        bypassCache: true
      })
      if (user && user.signInUserSession) {
        context.commit('setUser', user)
        return user
      }
    },
    getMemberProfile: async function (context) {
      try {
        console.log('Retrieving User Profile...')
        let response = await userApi.getMemberProfile()
        if (!response.error && response.profile !== undefined) {
          console.log('Profile Retrieved!')
          context.commit('setProfile', response.profile)
          return response.profile
        }
      } catch (e) {
        console.log('GetProfile Catch Error')
        console.log(e.error)
        context.commit('setProfile', { id: null })
      }
    },
    updateMemberProfile: async function (context, data) {
      console.log('Saving User Profile...')
      let response = await userApi.updateMemberProfile(data)
      if (!response.error && response.profile !== undefined) {
        console.log('Profile Saved!')
        context.commit('setProfile', response.profile)
        context.dispatch('refreshUser')
        return response.profile
      }

      console.log('UpdateProfile Error')
      console.log(response.error)
      return response
    },
    getCertificate: async function (context, data) {
      console.log('Getting user Certificate')
      let response = await userApi.getUserCertificate()
      console.log('GetCertResponse')
      console.log(response)
      return response
    }
  },
  getters: {
    getUser: function (state) {
      return state.user
    },
    getProfile: function (state) {
      return state.profile
    },
    isAdmin: function (state) {
      try {
        return (
          state.user.attributes['custom:capabilities'].indexOf(
            'administrator'
          ) >= 0
        )
      } catch (e) {
        return false
      }
    },
    isSponsor: function (state) {
      try {
        return (
          state.user.attributes['custom:capabilities'].indexOf('sponsor') >= 0
        )
      } catch (e) {
        return false
      }
    },
    isCommittee: function (state) {
      try {
        return (
          state.user.attributes['custom:capabilities'].indexOf('committee') >= 0
        )
      } catch (e) {
        return false
      }
    },
    isExecutive: function (state) {
      try {
        return (
          state.user.attributes['custom:capabilities'].indexOf('executive') >= 0
        )
      } catch (e) {
        return false
      }
    },
    isActiveSubscription: function (state) {
      try {
        if (state.subscription.type === 'life') return true
        let now = new Date().getTime()
        if (new Date(state.subscription.subscriptionEnds).getTime() >= now) {
          return true
        }
        return false
      } catch (e) {
        return false
      }
    },
    hasUserRegistered: function (state) {
      try {
        if (!state.subscription) return false
        if (state.subscription.type === 'life' || state.subscription.type === 'sponsor') return true
        const current = state.subscription.current
        if (current && current.name) return true
        if (!state.profile || !state.profile.membershipHistory) return false
        if (state.profile.membershipHistory.length <= 0) return false
        const lastMembership = state.profile.membershipHistory[0]
        const now = new Date()
        now.setFullYear(now.getFullYear() - 2)
        const yearDiff = new Date(now.toDateString())
        const endDate = new Date(new Date(lastMembership.subscriptionEnds).toDateString())
        
        if (endDate >= yearDiff) return true
        return false
      } catch (e) {
        return false
      }
    },
    getAccountMembers: function (state) {
      try {
        return state.family || []
      } catch (e) {
        return []
      }
    },
    getSubscription: function (state) {
      try {
        return state.subscription
      } catch (e) {
        return null
      }
    },
    getSecondary (state) {
      try {
        return state.secondary
      } catch (e) {
        return null
      }
    },
    getAddress: function (state) {
      try {
        return {
          street: state.address.street,
          suburb: state.address.suburb,
          postcode: state.address.postcode,
          state: state.address.state
        }
      } catch (e) {
        return {
          street: null,
          suburb: null,
          postcode: null,
          state: null
        }
      }
    }
  }
}

export default user
